if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        //if (this.isProductPage()) {
          //this.addStickyElements();
        //}
      }

      isProductPage() {
        return window.location.pathname.includes('/products/');
      }

      addStickyElements() {
            if (!this.submitButton || !this.form) return;
        
            const stickyBlock = document.createElement('div');
            stickyBlock.style.position = 'fixed';
            stickyBlock.style.bottom = '0';
            stickyBlock.style.left = '0';
            stickyBlock.style.right = '0';
            stickyBlock.style.zIndex = '500';
            stickyBlock.style.backgroundColor = '#fff';
            stickyBlock.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
            stickyBlock.style.padding = '10px 50px';
            stickyBlock.style.display = 'flex';
            stickyBlock.style.justifyContent = 'space-between';
            stickyBlock.style.alignItems = 'center';
            stickyBlock.style.gap = '20px';
            stickyBlock.style.transform = 'translateY(100%)';
            stickyBlock.style.transition = 'transform 0.3s ease-in-out';
            stickyBlock.style.visibility = 'hidden';
        
            const title = document.querySelector('.product__title h1')?.innerText.trim() || '';
            const description = document.querySelector('.rte.product-subtitle p')?.innerText.trim() || '';
            const price = document.querySelector('.price-item--regular')?.innerText.trim() || '';
        
            const leftBlock = document.createElement('div');
            leftBlock.style.flex = '1';
        
            const titleElement = document.createElement('h3');
            titleElement.innerText = title;
            titleElement.style.margin = '0';
            titleElement.style.fontSize = '18px';
            titleElement.style.fontWeight = '600';
        
            const descriptionElement = document.createElement('p');
            descriptionElement.innerText = description;
            descriptionElement.style.margin = '0';
            descriptionElement.style.fontSize = '14px';
            descriptionElement.style.lineHeight = '20px';
            descriptionElement.style.color = '#666';
        
            leftBlock.appendChild(titleElement);
            leftBlock.appendChild(descriptionElement);
        
            const rightBlock = document.createElement('div');
            rightBlock.style.display = 'flex';
            rightBlock.style.flexDirection = 'row';
            rightBlock.style.alignItems = 'center';
            rightBlock.style.gap = '16px';
        
            const priceElement = document.createElement('span');
            priceElement.innerText = price;
            priceElement.style.fontSize = '18px';
            priceElement.style.fontWeight = '600';
        
            const addToCartButton = document.createElement('button');
            addToCartButton.type = 'submit';
            addToCartButton.innerText = 'ADD TO CART';
            addToCartButton.style.width = '200px';
            addToCartButton.style.backgroundColor = '#252525';
            addToCartButton.style.color = '#ffffff';
            addToCartButton.style.padding = '17px 25px';
            addToCartButton.style.cursor = 'pointer';
        
            addToCartButton.addEventListener('click', () => {
              this.submitButton?.click();
            });
        
            rightBlock.appendChild(priceElement);
            rightBlock.appendChild(addToCartButton);
        
            stickyBlock.appendChild(leftBlock);
            stickyBlock.appendChild(rightBlock);
        
            const updateStickyVisibility = () => {
                if (window.innerWidth <= 768) {
                    stickyBlock.style.flexDirection = 'column';
                    stickyBlock.style.alignItems = 'center';
                    leftBlock.style.display = 'none';
                    addToCartButton.style.width = '100%';
                    addToCartButton.style.padding = '14px 24px';
                    stickyBlock.style.padding = '15px'; 
                    rightBlock.style.width = '100%';

                } else {
                    stickyBlock.style.flexDirection = 'row';
                    stickyBlock.style.alignItems = 'center';
                    leftBlock.style.display = 'block';
                    addToCartButton.style.width = '200px';
                    addToCartButton.style.padding = '17px 25px';
                    stickyBlock.style.padding = '10px 50px';

                }
            };
        
            const relatedSection = document.querySelector('#shopify-section-template--18593107902686__related-products');
        
            const handleScroll = () => {
              const scrollY = window.scrollY || window.pageYOffset;
        
              if (scrollY >= 1200) {
                stickyBlock.style.transform = 'translateY(0)';
                stickyBlock.style.visibility = 'visible';
              } else {
                stickyBlock.style.transform = 'translateY(100%)';
                stickyBlock.style.visibility = 'hidden';
              }
            };
        
            window.addEventListener('resize', updateStickyVisibility);
            window.addEventListener('scroll', handleScroll);
        
            updateStickyVisibility();
            handleScroll();
        
            document.body.appendChild(stickyBlock);
        }

      
      
        onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
